<template>
  <div>
    <modal
      v-show="sendPushModalVisible"
      @close="sendPushModalVisible = false"
      footer
      modalIsLarge
    >
      <template v-slot:title>
        <h5>Send Push Notification</h5>
      </template>
      <template v-slot:body>
        <div class="form-group">
          <label for="title">Title</label>
          <input
            type="text"
            class="form-control"
            name="title"
            placeholder="Hello World"
            v-model="pushNotification.title"
            disabled
          />
        </div>
        <div class="form-group">
          <label for="">Type</label>
          <select name="" id="" class="form-control" v-model="send_type">
            <option value="" disabled selected>Please Select type</option>
            <option value="test">Test</option>
            <option value="main">Main</option>
          </select>
        </div>
        <div class="form-group">
          <label for="body">Body</label>
          <textarea
            name="body"
            id=""
            disabled
            cols="30"
            rows="10"
            placeholder="Description..."
            class="form-control"
            v-model="pushNotification.body"
            style="resize: none"
          ></textarea>
        </div>
      </template>
      <template v-slot:footer>
        <button
          class="btn btn-success text-white"
          @click.prevent="sendPushFunc"
          :disabled="send_type === '' || sendLoading"
        >
          <span class="custom-loader" v-if="sendLoading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;"
              >Sending Notification...</span
            >
          </span>
          <span v-else>
            Send Notification
          </span>
        </button>
        <button @click.prevent="sendPushModal" class="btn btn-secondary">
          Cancel
        </button>
      </template>
    </modal>
    <form @submit.prevent="createPushNotification">
      <modal
        v-show="isPushNotificationModal"
        @close="closePushNotificationModal"
        footer
      >
        <template v-slot:title>
          <h5>
            {{ pushNotification.id ? " Update" : "Create" }}Create Push
            Notification
          </h5>
        </template>
        <template v-slot:body>
          <div class="form-group">
            <label for="title">Title</label>
            <input
              type="text"
              class="form-control"
              name="title"
              placeholder="Hello World"
              v-model="pushNotification.title"
            />
          </div>
          <div class=" form-group" v-if="pushNotification.id === ''">
            <label for="">Send Option</label>
            <select
              name=""
              id=""
              class="form-control"
              v-model="pushNotification.send"
            >
              <option value="" selected disabled>Please Select</option>
              <option value="now">Now</option>
              <option value="later">Later</option>
            </select>
          </div>

          <div class="form-group">
            <label for="group">Group</label>
            <select
              name="type"
              id=""
              class="form-control"
              v-model="pushNotification.group"
            >
              <option value="" selected disabled>Select Type</option>
              <option value="all-customers">All Customer</option>
              <option value="all-transactional-customers"
                >All Transactional Customers</option
              >
              <option value="customer-user-range-by-date"
                >Customer User Range By Date</option
              >
            </select>
          </div>
          <div
            class="form-group"
            v-if="pushNotification.group === 'customer-user-range-by-date'"
          >
            <label for="start_date">Start Date</label>
            <input
              type="date"
              name=""
              id=""
              class="form-control"
              v-model="pushNotification.start_date"
            />
          </div>
          <div
            class="form-group"
            v-if="pushNotification.group === 'customer-user-range-by-date'"
          >
            <label for="end_date">End Date</label>
            <input
              type="date"
              class="form-control"
              v-model="pushNotification.end_date"
            />
          </div>

          <div class="form-group">
            <label for="body">Body</label>
            <textarea
              name="body"
              id=""
              cols="30"
              rows="10"
              placeholder="Description..."
              class="form-control"
              v-model="pushNotification.body"
              style="resize: none"
            ></textarea>
          </div>
        </template>
        <template v-slot:footer>
          <button class="btn btn-success" @click.prevent="sendPushModal">
            Push Notification
          </button>
          <button
            type="submit"
            class="button"
            :disabled="creatingPushNotificationLoading || !formIsValid"
          >
            <span class="custom-loader" v-if="creatingPushNotificationLoading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;"
                >Creating Notification...</span
              >
            </span>
            <span v-else>
              {{ pushNotification.id ? "Create" : "Add" }} Notification
            </span>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closePushNotificationModal"
          >
            Cancel
          </button>
        </template>
      </modal>
    </form>
    <loader-ring
      v-if="getPushNotificationLoading"
      class="loader-center"
    ></loader-ring>
    <div v-else>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h1 class="mb-2 font-regular">Notifications</h1>
        </div>
        <div class="col-auto">
          <button
            class="button button--outline text-uppercase"
            @click="showPushNotificationModal"
          >
            Add Notification
          </button>
        </div>
      </div>

      <div class="card card--no-shadow">
        <div class="card-header">
          <slot name="header">
            <h4 class="card-title">Notifications</h4>
          </slot>
        </div>
        <div class="card-content">
          <div class="card-body">
            <CDataTable
              :items="pushNotifications"
              :fields="fields"
              :items-per-page="small ? 10 : 5"
              pagination
              sorter
              tableFilter
            >
              <template #created_at="{item}">
                <td class="table--action-mobile">
                  {{ item.created_at | date }}
                </td>
              </template>
              <template #action="{item}">
                <td class="table--action-mobile">
                  <!-- <router-link class="button" :to="{name: 'Remittance Plan', params: {slug: item.id}}">
                                        View
                                    </router-link> -->
                  <button
                    class="button btn-sucess"
                    @click="showUpdateModal(item)"
                    style="background-color: #0bc681;"
                  >
                    View
                  </button>
                </td>
              </template>
            </CDataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CDataTable from "@/components/CDataTable.vue";
import ApiService from "@/services/api.service";
import ErrorService from "@/services/error.service";
import Swal from "sweetalert2";

const fields = ["title", "body", "created_at", "action"];
export default {
  name: "PushNotification",
  components: {
    CDataTable
  },
  data() {
    return {
      currentDate: Date.now(),
      fields,
      small: false,

      getPushNotificationLoading: false,
      isPushNotificationModal: false,
      creatingPushNotificationLoading: false,
      pushNotifications: [],
      pushNotification: {
        id: "",
        group: "",
        body: "",
        title: "",
        start_date: "",
        send: "",
        end_date: ""
      },
      current: 1,
      next_page: 1,
      total: 1,
      sendPushModalVisible: false,
      send_type: "",
      sendLoading: false
    };
  },
  computed: {
    formIsValid() {
      if (
        this.pushNotification.group !== "" &&
        this.pushNotification.body !== "" &&
        this.pushNotification.send !== "" &&
        this.pushNotification.title !== ""
      ) {
        if (this.pushNotification.group === "customer-user-range-by-date") {
          return (
            this.pushNotification.start_date !== "" &&
            this.pushNotification.end_date !== ""
          );
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    sendPushModal() {
      this.isPushNotificationModal = !this.isPushNotificationModal;
      this.sendPushModalVisible = !this.sendPushModalVisible;
    },
    async sendPushFunc() {
      this.sendLoading = true;
      try {
        const response = await ApiService.post("push/send", {
          id: this.pushNotification.id,
          type: this.send_type
        });
        this.sendLoading = false;
        this.sendPushModalVisible = false;
        this.closePushNotificationModal();
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.getNotifications();
      } catch (error) {
        this.sendLoading = false;
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
        console.log(_error);
      }
    },
    showUpdateModal(item) {
      this.pushNotification = Object.assign({}, item);
      this.showPushNotificationModal();
      console.log(this.pushNotification);
    },
    closePushNotificationModal() {
      this.isPushNotificationModal = false;
      // this.pushNotification = {};
      this.pushNotification.id = "";
      this.pushNotification.group = "";
      this.pushNotification.body = "";
      this.pushNotification.title = "";
      this.pushNotification.start_date = "";
      this.pushNotification.send = "";
      this.pushNotification.end_date = "";
    },
    showPushNotificationModal() {
      this.isPushNotificationModal = true;
    },
    async getNotifications() {
      try {
        this.getPushNotificationLoading = true;
        const response = await ApiService.get("push/all");
        this.pushNotifications = response.data.data.data;
        this.current = response.data.data.current_page;
        this.total = response.data.data.last_page;
        this.getPushNotificationLoading = false;
      } catch (error) {
        this.getPushNotificationLoading = false;
        console.log(error.response);
      }
    },
    async createPushNotification() {
      try {
        this.creatingPushNotificationLoading = true;
        const response = await ApiService.post(
          "push/create",
          this.pushNotification
        );
        this.creatingPushNotificationLoading = false;
        this.closePushNotificationModal();
        this.getNotifications();

        Swal.fire({
          title: "Success",
          text: response.data.response_message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
      } catch (error) {
        this.creatingPushNotificationLoading = false;
        this.closePushNotificationModal();
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
        console.log(_error);
      }
    }
  },
  mounted() {
    this.getNotifications();
  }
};
</script>

<style scoped></style>
